import React, { useState } from 'react';
import PropTypes from 'prop-types';
import AccordionGroup from '@cx/ui/AccordionGroup';
import SelectInput from '@cx/ui/SelectInput';

export const MakeFilterComponent = props => {
  const { options } = props.filter;
  const [selectedValue, setSelectedValue] = useState('');

  const handleSelect = (cxEvent, isValid, domEvent) => {
    setSelectedValue(cxEvent.target.value);
  };

  const handleApply = () => {
    const selected = selectedValue;
    props.handleFilterUpdate('make', selected.toLowerCase());
  };

  const handleReset = ({ target }) => {
    const selected = '';
    setSelectedValue(selected);
    props.handleFilterUpdate('make', selected);
  };

  return (
    <section className="vlp-filter">
      <AccordionGroup.Container htmlId="makeFilter" independent>
        <AccordionGroup.Item header="Make" eventKey="1" htmlId="makeFilterItem">
          <div className="form-group">
            <SelectInput
              htmlId="makeSelect"
              label="Item"
              name="makeSelect"
              onChange={handleSelect}
              options={options.map((option, index) => ({
                value: option,
                label: option
              }))}
              value={selectedValue}
            />
          </div>
          <button type="button" className="btn btn-light" id="btnReset" onClick={handleReset} disabled={selectedValue === ''}>
            Reset
          </button>
          &nbsp;
          <button type="button" className="btn btn-primary" id="btnApply" onClick={handleApply} disabled={selectedValue === ''}>
            Apply
          </button>
        </AccordionGroup.Item>
      </AccordionGroup.Container>
    </section>
  );
};

MakeFilterComponent.propTypes = {
  filter: PropTypes.object,
  handleFilterUpdate: PropTypes.func
};



// WEBPACK FOOTER //
// ./src/components/vehicles/filters/filter/makeFilter.component.js